import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { DialogActions, Grid } from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import MaxFourNumber from "Components/Input/components/MaxFourNumber";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import { getMahdoodeFani, updateMahdoodeFani } from "Stores/actions";
import showNotify from "Helpers/Notify";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from "react-i18next";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from "react-bootstrap-icons";

function MahdoodeFaniRowEditor({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { selectedBazsho, mahdoodeFaniPagination, isWidthFani, isHeightFani } =
    useSelector((state) => ({
      selectedBazsho: state.yaragh.selectedBazsho,
      mahdoodeFaniPagination: state.yaragh.mahdoodeFaniPagination,
      isWidthFani: state.yaragh.isWidthFani,
      isHeightFani: state.yaragh.isHeightFani,
    }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [checkValid, setCheckValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    mahdoodeName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
    minW: {
      type: "millimeter",
      value: "0",
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
      },
      col: {
        sm: 3,
        xs: 6,
      },
    },
    maxW: {
      type: "millimeter",
      value: "0",
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
        notZero: true,
      },
      col: {
        sm: 3,
        xs: 6,
      },
    },
    minH: {
      type: "millimeter",
      value: "",
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
      },
      col: {
        sm: 3,
        xs: 6,
      },
    },
    maxH: {
      type: "millimeter",
      value: "0",
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
        notZero: true,
      },
      col: {
        sm: 3,
        xs: 6,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { mahdoodeName, minH, maxH, minW, maxW } = controls;
      if (
        (isWidthFani && minW.value >= maxW.value) ||
        (isHeightFani && minH.value >= maxH.value)
      ) {
        showNotify({
          text: t("minBTmax"),
          customClass: "error",
        });
      } else {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdPop: +selectedBazsho.Id,
            id: row.Id,
            Name: mahdoodeName.value,
            MinWidth: +convertToEnglishNumber(minW.value),
            MaxWidth: +convertToEnglishNumber(maxW.value),
            MinHeight: +convertToEnglishNumber(minH.value),
            Maxheight: +convertToEnglishNumber(maxH.value),
          };
          if (await dispatch(updateMahdoodeFani(data))) {
            const params = {
              KeyGroup: read("groupKey"),
              KeyUser: read("userKey"),
              IdPop: +selectedBazsho.Id,
              Limit: mahdoodeFaniPagination.Limit,
              Page: mahdoodeFaniPagination.Page,
            };
            await dispatch(getMahdoodeFani(params));
            handleDialog();
          }
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }
    } else {
      setCheckValid(true);
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  const onEnter = () => onClear();

  const onClear = () => {
    setCheckValid(false);
    setFormValid({});
    setControls({ mahdoodeName: { value: row.Code } });
    setControls({ minH: { value: row.MinHeight } });
    setControls({ maxH: { value: row.MaxHeight } });
    setControls({ minW: { value: row.MinWidth } });
    setControls({ maxW: { value: row.MaxWidth } });
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={row.IsG && read("StypeU") !== "1"}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        TransitionProps={{
          onEnter: onEnter,
        }}
        fullWidth
        maxWidth="sm"
      >
        <BackDropLoading loading={loading} />
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              {<Translator id={"newAccessoryRangeFani"} />}
              {selectedBazsho && <span> ({selectedBazsho.Name})</span>}
            </p>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              {Object.keys(controls)
                .filter(
                  (key) =>
                    controls[key].type !== "millimeter" ||
                    (controls[key].type === "millimeter" &&
                      ((isHeightFani && key.includes("H")) ||
                        (isWidthFani && key.includes("W"))))
                )
                .map((key) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key}
                    >
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        value={controls[key].value}
                        placeholder={t(key)}
                        validation={controls[key].validation}
                        checkValid={checkValid}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        endIcon={
                          controls[key].type === "millimeter" ? (
                            <Translator id="millimeter" />
                          ) : (
                            ""
                          )
                        }
                        minLength={controls[key]?.validation?.minLength}
                        maxlength={controls[key]?.validation?.maxLength}
                        inputComponent={
                          controls[key].type === "millimeter" && MaxFourNumber
                        }
                      />
                    </Grid>
                  );
                })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default MahdoodeFaniRowEditor;
